import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { EndocrineThyroidDiagramContent } from "./EndocrineThyroidDiagram";
import { EndocrineThyroidKeyContent } from "./EndocrineThyroidKey";

const SvgEndocrineThyroidDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1344, 1622)}
      viewBox={diagramOnly ? "0 208 1024 1344" : "0 0 1024 1622"}
    >
      <g id="endocrine-thyroid-diagram+key" clipPath="url(#clip0_18293_224297)">
        <rect width={1024} height={diagramOnly ? 1344 : 1622} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <EndocrineThyroidKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 70)` : undefined}>
          <EndocrineThyroidDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18293_224297">
          <rect width={1024} height={1622} fill="white" />
        </clipPath>
        <clipPath id="clip1_18293_224297">
          <rect width={1024} height={1344} fill="white" transform="translate(0 208)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgEndocrineThyroidDiagramKey;
